import { graphql } from "gatsby"

export const BblIntroTextBlockFragment = graphql`
  fragment BblIntroTextBlock on WpBlock {
    ... on WpBblIntroTextBlock {
      name
      attributes {
        className
      }
    }
  }
`

// This is the string version of this that is used within previews and without WP prefixes
export const BblIntroTextBlockPreview = `
    ... on BblIntroTextBlock {
        name
        attributes {
            className
        }
    }
`
